// extracted by mini-css-extract-plugin
export default {"icon":"FeatureList_icon__JaLvN","iconWrapper":"FeatureList_iconWrapper__BuBRB","iconTitle":"FeatureList_iconTitle__mPUn8","row":"FeatureList_row__OQiO6"};